import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

export interface IServerErrorPopUpInit {
    xhr: any;
    thrownError: any;
}

@ModuleName("ServerErrorPopUp")
export class ServerErrorPopUp implements AxInit {

    private i18NHelper = new I18nHelper();

    AxInit(init: IServerErrorPopUpInit): void {
        let errorText = `<div>${this.i18NHelper.GetTranslation(Translations.ServerErrorText1)}</div>
                            <div>${this.i18NHelper.GetTranslation(Translations.ServerErrorText2)}</div>`;

        if (init == null || typeof init == 'undefined') {
            return;
        }

        Swal.fire({
            title: this.i18NHelper.GetTranslation(Translations.Oops),
            icon: 'warning',
            html: errorText
        }).then(() => {
            location.reload();
        });
    }
}